import { render, staticRenderFns } from "./DivorceConsentOrderSignedYN.vue?vue&type=template&id=656be264"
import script from "./DivorceConsentOrderSignedYN.vue?vue&type=script&lang=js"
export * from "./DivorceConsentOrderSignedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports